import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableLtlHazmat = (): boolean => {
  return useFeatureFlag(FeatureFlagDeclarations.enableLtlHazmat);
};
